"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _globals = require("../../lib/constants/globals");
const ProviderProfileLink = _ref => {
  let {
    provider,
    pageSection,
    navCallback,
    navUrl,
    track,
    children,
    ...props
  } = _ref;
  const handleClick = e => {
    e.preventDefault();
    track(_globals.LOGGING.MESSAGE.VIEW_PROVIDER, {
      page_section: pageSection
    });
    navCallback(e);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.default, (0, _extends2.default)({}, props, {
    href: navUrl,
    id: `view-details-${provider.id}`,
    onClick: handleClick
  }), children);
};
var _default = exports.default = ProviderProfileLink;
ProviderProfileLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderProfileLink"
};